var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative h-full w-full"},[_c('div',{ref:"mapRef",staticClass:"h-full w-full"}),_vm._v(" "),_vm._t("default",null,null,{ ready: _setup.ready, mapRef: _setup.mapRef }),_vm._v(" "),_c('div',{staticClass:"absolute right-4 top-4 flex flex-col gap-4"},[_vm._t("controls")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }